import { faUser } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'styled-components'

import { Button, FormattedMessage } from '@b-stock/fe-core/bstock-react'
import { Typography } from '@b-stock/fe-core/design-system'
import { designColors } from '@b-stock/fe-core/theme'

import { redirectSignUp, redirectToAuth } from '@/helpers/auth'

const UnAuthSectionContainer = styled.div`
  grid-area: shipment;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    margin: 0;
  }
`

const UnAuthSectionIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 4rem;
  height: 4rem;
  color: ${designColors.neutral.veryDarkGray};
  border: 0.0625rem solid ${designColors.neutral.mediumGray};
  border-radius: 50%;
  font-size: 2rem;
`

const UnAuthSectionText = styled.p`
  ${Typography.Title2}
  color: ${designColors.neutral.black};
  && {
    margin-top: 1.5rem;
  }
`

const UnAuthSectionActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 3rem;
`

export const UnAuthWarning = ({
  reason,
  className,
  children,
}: {
  reason: React.ReactElement | string
  className?: string
  children?: React.ReactNode
}) => {
  return (
    <UnAuthSectionContainer data-testid="UnAuthWarning" className={className}>
      <UnAuthSectionIconWrapper>
        <FontAwesomeIcon icon={faUser} />
      </UnAuthSectionIconWrapper>

      <UnAuthSectionText>
        <FormattedMessage
          id="Common.unAuthMessage.description"
          values={{ reason }}
        />
      </UnAuthSectionText>

      <UnAuthSectionActions>
        <Button onClick={redirectToAuth} size="medium" appearance="secondary">
          <FormattedMessage id="Common.signIn" />
        </Button>
        <Button onClick={redirectSignUp} size="medium" appearance="primary">
          <FormattedMessage id="Common.register" />
        </Button>
      </UnAuthSectionActions>

      {children ? children : null}
    </UnAuthSectionContainer>
  )
}
